import React, { useEffect, useRef, useState } from "react";
import {
  Typography,
  Stack,
  Box,
  Grid,
  Divider,
  Radio,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Checkbox,
  TextField,
  IconButton,
  Card,
  CardContent,
  useMediaQuery
} from "@mui/material";
import { ReactComponent as EditIcon } from "../../../../Icons/EditIcon.svg";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as FormIcon } from "../../../../Icons/CommonFormIcon.svg";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { removeData } from "../../../../Redux/Feature/AdminSlice";
import axiosInstance from "../../../../api/axiosInstance";
import { useTranslation } from "react-i18next";
import FormatNumber from "../../../../CommonComponents/FormatNumber";

export default function Review({
  setStepperCount,
  ServicesValue,
  PersonalData,
  RoomsData,
  trigger,
  setPersonalData,
  checked,
  setChecked,
  email
}) {
  // const initial_Emergency_contact = { Emergency_name: "", Emergency_contact_no: "", Emergency_email: "", Emergency_whatsapp: "", Emergency_wechat: "", Emergency_line: "", Emergency_kakaotalk: "" }
  // const [Emergency_contact, setEmergency_contact] = useState([initial_Emergency_contact])
  // const [Details, setDetails] = useState({ name: "", dob: "", nationality: "", gender: "", passport_no: "", school: "", contact_no: "", wechat: "", whatsapp: "", line: "", kakaotalk: "", note: "", ipaFile: "" })
  const { ServicesData, OtherServiceData } = useSelector((state) => state.CommonData);
  const isMobile = useMediaQuery('(max-width : 600px)')
  const { Details, Emergency_contact } = PersonalData;
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {t} = useTranslation()
  
  const {
    otherServices,
    fligt_no,
    arrival_date,
    arrival_time,
    landingServices,
  } = ServicesValue;

  // console.log(ServicesData);

  // useEffect(() => {
  //   if (trigger) {
  //     setStepperCount(5);
  //   }
  // }, [trigger]);

  useEffect(() => {
    window.scrollTo({
      top : 0,
      left : 0,
      behavior : 'smooth'
    })
  }, [])

  console.log(PersonalData)
 

  useEffect(() => {
    setPersonalData((prevState) => ({
      ...prevState,
      Details: {
        ...prevState.Details,
        agreement: checked,
      },
    }));
  }, [checked]);

  const checkBoxChange = (e) => {
    setChecked(e.target.checked);
  };

  const handleSubmit = async () => {
    const formData = new FormData()
    formData.append("email", email)
    formData.append("agreement", checked)
  
    await axiosInstance.post(`add-application-step-data`, formData)
    .then((response) => console.log(response))
    .catch((error) => {
      console.log(error)
      if(error.response.status === 401){
        navigate('/login')
        dispatch(removeData())
    }
    })
  }


  // For local files (before upload) -> File object
function getLocalPreview(file) {
  console.log(file)
  if (!file) return null;
  return URL.createObjectURL(file);
}

// For uploaded files (after upload) -> server path
function getUploadedFileUrl(file) {
  console.log(file)
  if (!file) return null;
  return `${process.env.REACT_APP_FILE_PATH}/${file.filename}`;
}

function isLocalFile(file) {
  return file instanceof File;
}

console.log(PersonalData?.Details?.ipaFile)


  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Card
          sx={{ width: "90%", border: "0px solid #E5E7EB", boxShadow: "none" }}
        >
          <CardContent style={{ padding: 0, margin: 0 }}>
            <Box
              sx={{
                color: "black",
                margin: "10px 40px 10px 0px",
                cursor: "pointer",
                "&:hover": {
                  color: "black",
                },
              }}
            >
              <ArrowBackIcon
                sx={{
                  border: "1px solid grey",
                  padding: "2px 3px",
                  fontSize: "2rem",
                  borderRadius: "3px",
                }}
                onClick={() => {
                  setStepperCount(3);
                }}
              />
            </Box>
            <Typography
              style={{
                fontSize: "1.7rem",
                fontWeight: 700,
                margin: "30px 0px 40px 0px",
              }}
            >
              {t("Applicant Information")}
            </Typography>
          </CardContent>
        </Card>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Card
          sx={{
            width: "90%",
            border: "1px solid #E5E7EB",
            borderRadius: "6px",
            mb: "30px",
          }}
        >
          <CardContent style={{ padding: 0, margin: 0 }}>
            

            {/* <Stack direction="row" alignItems="center" gap={1}>
                                <Typography variant='h9_3' color="text_blue">Tuition Arrangement  -</Typography>
                                <Typography lineHeight="37px" variant='h9_1' color="neutral_7">Not Included</Typography>
                            </Stack>
                            <Stack direction="row" alignItems="center" gap={1}>
                                <Typography variant='h9_3' color="text_blue">English IELTS, SAT Training  -</Typography>
                                <Typography lineHeight="37px" variant='h9_1' color="neutral_7">Not Included</Typography>
                            </Stack>
                            <Stack direction="row" alignItems="center" gap={1}>
                                <Typography variant='h9_3' color="text_blue">University Course Training  -</Typography>
                                <Typography lineHeight="37px" variant='h9_1' color="neutral_7">Not Included</Typography>
                            </Stack>
                            <Stack direction="row" alignItems="center" gap={1}>
                                <Typography variant='h9_3' color="text_blue">Counselling  -</Typography>
                                <Typography lineHeight="37px" variant='h9_1' color="green">Included</Typography>
                            </Stack>
                            <Stack direction="row" alignItems="center" gap={1}>
                                <Typography variant='h9_3' color="text_blue">Guardian Services  -</Typography>
                                <Typography lineHeight="37px" variant='h9_1' color="neutral_7">Not Included</Typography>
                            </Stack> */}

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#FCFCFD",
                padding: 2,
                border: "1px solid #E5E7EB",
                borderRadius: "6px 6px 0px 0px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <FormIcon style={{ marginRight: "10px" }} />
                <Typography variant="h6_1">{t("Personal Details")}</Typography>
              </Box>
              <Button
                onClick={() => {
                  setStepperCount(1);
                }}
                startIcon={<EditIcon fill="#FFFFFF" />}
                sx={{
                  height: "40px",
                  width: "100px",
                  fontSize: "16px",
                  fontWeight: 500,
                }}
                variant="standard"
              >
                {t("Edit")}
              </Button>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                margin: isMobile ? "20px" : "20px 50px 20px 50px",
              }}
            >
              <Box>
                <InputLabel sx={{ marginBottom: "10px" }} variant="standard">
                  {t("name")}
                </InputLabel>
                <Typography variant="h7_1" color="text_blue">
                  {Details?.name || '-'}
                </Typography>
              </Box>

              <Box sx={{width : '30%'}}>
                <InputLabel sx={{ marginBottom: "10px" }} variant="standard">
                  {t("nationality")}
                </InputLabel>
                <Typography variant="h7_1" color="text_blue">
                  {Details?.nationality || '-'}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                margin: isMobile ? "20px" : "20px 50px 20px 50px",
              }}
            >
              <Box>
                <InputLabel sx={{ marginBottom: "10px" }} variant="standard">
                  {t("Passport number")}
                </InputLabel>
                <Typography variant="h7_1" color="text_blue">
                  {Details?.passport_no || '-'}
                </Typography>
              </Box>

              <Box sx={{width : '30%'}}>
                <InputLabel sx={{ marginBottom: "10px" }} variant="standard">
                  {t("Gender")}
                </InputLabel>
                <Typography variant="h7_1" color="text_blue">
                  {Details?.gender || '-'}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                margin: isMobile ? "20px" : "20px 50px 20px 50px",
              }}
            >
              <Box>
                <InputLabel sx={{ marginBottom: "10px" }} variant="standard">
                  {t("dob")}
                </InputLabel>
                <Typography variant="h7_1" color="text_blue">
                  {moment(Details?.dob?.$d).format("MMM DD, YYYY") || '-'}
                </Typography>
              </Box>

              <Box sx={{width : '30%'}}>
                <InputLabel sx={{ marginBottom: "10px" }} variant="standard">
                  {t("School")}
                </InputLabel>
                <Typography variant="h7_1" color="text_blue">
                  {Details?.school || '-'}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                backgroundColor: "#FCFCFD",
                padding: 2,
                border: "1px solid #E5E7EB",
                borderRadius: "6px 6px 0px 0px",
              }}
            >
              <FormIcon style={{ marginRight: "10px" }} />
              <Typography variant="h6_1">{t("Contact")}</Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                margin: isMobile ? "20px" : "20px 50px 20px 50px",
              }}
            >
              <Box>
                <InputLabel sx={{ marginBottom: "10px" }} variant="standard">
                  {t("Contact number")}
                </InputLabel>
                <Typography variant="h7_1" color="text_blue">
                  {Details?.contact_no?.length > 0  ? <FormatNumber number={`+${Details?.contact_no}`} /> : '-'}
                </Typography>
              </Box>

              <Box sx={{width : '30%'}}>
                <InputLabel sx={{ marginBottom: "10px" }} variant="standard">
                  {t("wechat")}
                </InputLabel>
                <Typography variant="h7_1" color="text_blue">
                  {Details?.wechat?.length > 0 ? `${Details?.wechat}` : '-'}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                margin: isMobile ? "20px" : "20px 50px 20px 50px",
              }}
            >
              <Box>
                <InputLabel sx={{ marginBottom: "10px" }} variant="standard">
                  {t("whatsapp")}
                </InputLabel>
                <Typography variant="h7_1" color="text_blue">
                  {Details?.whatsapp?.length > 0 ? `${Details?.whatsapp}` : '-'}
                </Typography>
              </Box>

              <Box sx={{width : '30%'}}>
                <InputLabel sx={{ marginBottom: "10px" }} variant="standard">
                  {t("line")}
                </InputLabel>
                <Typography variant="h7_1" color="text_blue">
                  {Details?.line?.length > 0 ? `${Details?.line}` : '-'}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                margin: isMobile ? "15px" : "20px 50px 20px 50px",
              }}
            >
              <Box>
                <InputLabel sx={{ marginBottom: "10px" }} variant="standard">
                  {t("KakaoTaalk")}
                </InputLabel>
                <Typography variant="h7_1" color="text_blue">
                  {Details?.kakaotalk?.length > 0 ? `${Details?.kakaotalk}` : '-'}
                </Typography>
              </Box>

              <Box sx={{width : '30%'}}>
                <InputLabel sx={{ marginBottom: "10px" }} variant="standard">
                  {t("Zalo")}
                </InputLabel>
                <Typography variant="h7_1" color="text_blue">
                  {Details?.zalo?.length > 0 ? `${Details?.zalo}` : '-'}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#FCFCFD",
                padding: 2,
                border: "1px solid #E5E7EB",
                borderRadius: "6px 6px 0px 0px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <FormIcon style={{ marginRight: "10px" }} />
                <Typography variant="h6_1">{t("Emergency Contact")}</Typography>
              </Box>
              {/* <Button
                onClick={() => {
                  setStepperCount(1);
                }}
                startIcon={<EditIcon fill="#FFFFFF" />}
                sx={{
                  height: "40px",
                  width: "100px",
                  fontSize: "16px",
                  fontWeight: 500,
                }}
                variant="standard"
              >
                Edit
              </Button> */}
            </Box>

            {Emergency_contact?.map((item, index) => (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "20px",
                  }}
                >
                  <Card sx={{ width: "95%", border: "1px solid #E5E7EB" }}>
                    <CardContent sx={{ padding: 3, marging: 0 }}>
                      <Typography variant="h7_3">
                        {t("Contact")} {index + 1}
                      </Typography>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          m: isMobile ? 0 : 3,
                          flexDirection : isMobile ? "column" : "row",
                          gap : 3,
                          mt : isMobile ? 2 : 0 
                        }}
                      >
                        <Box display={"flex"} sx={{flexDirection:"column",justifyContent:"flex-start"}}>
                          <InputLabel
                            sx={{ marginBottom: "10px" }}
                            variant="standard"
                          >
                            {t("Contact name")}
                          </InputLabel>
                          <Typography variant="h7_1" color="text_blue">
                            {item?.Emergency_name || '-'}
                          </Typography>
                        </Box>
                        <Box sx={{width : isMobile ? "100%" : '28%'}}>
                          <InputLabel
                            sx={{ marginBottom: "10px" }}
                            variant="standard"
                          >
                            {t("Contact mobile number")}
                          </InputLabel>
                          <Typography variant="h7_1" color="text_blue">
                            {item?.Emergency_contact_no?.length > 0 ? <FormatNumber number={`+${item?.Emergency_contact_no}`} /> : '-'}
                          </Typography>
                        </Box>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          m: isMobile ? 0 : 3,
                          flexDirection : isMobile ? "column" : "row",
                          gap : 3,
                          mt : isMobile ? 2 : 0 
                        }}
                      >
                        <Box>
                          <InputLabel
                            sx={{ marginBottom: "10px" }}
                            variant="standard"
                          >
                            {t("email")}
                          </InputLabel>
                          <Typography variant="h7_1" color="text_blue">
                            {item?.Emergency_email || '-'}
                          </Typography>
                        </Box>

                        <Box sx={{width : isMobile ? "100%" : '28%'}}>
                          <InputLabel
                            sx={{ marginBottom: "10px" }}
                            variant="standard"
                          >
                            {t("whatsapp")}
                          </InputLabel>
                          <Typography variant="h7_1" color="text_blue">
                            {item?.Emergency_whatsapp?.length > 0 ? `${item?.Emergency_whatsapp}` : '-'}
                          </Typography>
                        </Box>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          m: isMobile ? 0 : 3,
                          flexDirection : isMobile ? "column" : "row",
                          gap : 3,
                          mt : isMobile ? 2 : 0 
                        }}
                      >
                        <Box>
                          <InputLabel
                            sx={{ marginBottom: "10px" }}
                            variant="standard"
                          >
                            {t("wechat")}
                          </InputLabel>
                          <Typography variant="h7_1" color="text_blue">
                            {item?.Emergency_wechat?.length > 0 ? `${item?.Emergency_wechat}` : '-'}
                          </Typography>
                        </Box>

                        <Box sx={{width : isMobile ? "100%" :'28%'}}>
                          <InputLabel
                            sx={{ marginBottom: "10px" }}
                            variant="standard"
                          >
                            {t("line")}
                          </InputLabel>
                          <Typography variant="h7_1" color="text_blue">
                            {item?.Emergency_line?.length > 0 ? `${item?.Emergency_line}` : '-'}
                          </Typography>
                        </Box>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          m: isMobile ? 0 : 3,
                          flexDirection : isMobile ? "column" : "row",
                          gap : 3,
                          mt : isMobile ? 2 : 0 
                        }}
                      >
                        <Box>
                          <InputLabel
                            sx={{ marginBottom: "10px" }}
                            variant="standard"
                          >
                            {t("KakaoTalk")}
                          </InputLabel>
                          <Typography variant="h7_1" color="text_blue">
                            {item?.Emergency_kakaotalk?.length > 0 ? `${item?.Emergency_kakaotalk}` : '-'}
                          </Typography>
                        </Box>

                        <Box sx={{width : isMobile ? "100%" :'28%'}}>
                          <InputLabel
                            sx={{ marginBottom: "10px" }}
                            variant="standard"
                          >
                            {t("KakaoTalk")}
                          </InputLabel>
                          <Typography variant="h7_1" color="text_blue">
                            {item?.Emergency_zalo?.length > 0 ? `${item?.Emergency_zalo}` : '-'}
                          </Typography>
                        </Box>
                      </Box>

                    
                    </CardContent>
                  </Card>
                </Box>
              </>
            ))}


<Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#FCFCFD",
                padding: 2,
                border: "1px solid #E5E7EB",
                borderRadius: "6px 6px 0px 0px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <FormIcon style={{ marginRight: "10px" }} />
                <Typography variant="h6_1">{t("IPA File")}</Typography>
              </Box>
              </Box>

<Box sx={{p : 2}}>
                      {PersonalData?.Details?.ipaFile ? (
  <div>
    {((isLocalFile(PersonalData?.Details?.ipaFile[0]) ? PersonalData?.Details?.ipaFile[0].type : PersonalData?.Details?.ipaFile.mimetype) === "application/pdf") ? (
      <iframe
        src={isLocalFile(PersonalData?.Details?.ipaFile[0]) ? getLocalPreview(PersonalData?.Details?.ipaFile[0]) : getUploadedFileUrl(PersonalData?.Details?.ipaFile)}
        width="100%"
        height="500px"
        title="PDF Preview"
      />
    ) : (
      <img
        src={isLocalFile(PersonalData?.Details?.ipaFile[0]) ? getLocalPreview(PersonalData?.Details?.ipaFile[0]) : getUploadedFileUrl(PersonalData?.Details?.ipaFile)}
        alt="IPA File"
        style={{ width: "100%", height: "auto" }}
      />
    )}
  </div>
) : null}
                      </Box>



                      <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#FCFCFD",
                padding: 2,
                border: "1px solid #E5E7EB",
                borderRadius: "6px 6px 0px 0px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <FormIcon style={{ marginRight: "10px" }} />
                <Typography variant="h6_1">{t("Passport")}</Typography>
              </Box>
              </Box>

<Box sx={{p : 2}}>
                      {PersonalData?.Details?.passport ? (
  <div>
    {((isLocalFile(PersonalData?.Details?.passport[0]) ? PersonalData?.Details?.passport[0].type : PersonalData?.Details?.passport.mimetype) === "application/pdf") ? (
      <iframe
        src={isLocalFile(PersonalData?.Details?.passport[0]) ? getLocalPreview(PersonalData?.Details?.passport[0]) : getUploadedFileUrl(PersonalData?.Details?.passport)}
        width="100%"
        height="500px"
        title="PDF Preview"
      />
    ) : (
      <img
        src={isLocalFile(PersonalData?.Details?.passport[0]) ? getLocalPreview(PersonalData?.Details?.passport[0]) : getUploadedFileUrl(PersonalData?.Details?.passport)}
        alt="IPA File"
        style={{ width: "100%", height: "auto" }}
      />
    )}
  </div>
) : null}
                      </Box>


<Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#FCFCFD",
                padding: 2,
                border: "1px solid #E5E7EB",
                borderRadius: "6px 6px 0px 0px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <FormIcon style={{ marginRight: "10px" }} />
                <Typography variant="h6_1">{t("Services")}</Typography>
              </Box>
              {/* <Button
                onClick={() => {
                  setStepperCount(3);
                }}
                startIcon={<EditIcon fill="#FFFFFF" />}
                sx={{
                  height: "40px",
                  width: "100px",
                  fontSize: "16px",
                  fontWeight: 500,
                }}
                variant="standard"
              >
                Edit
              </Button> */}
            </Box>

            <Box style={{ margin: isMobile ? "5px":"10px" }}>
              <Typography
                variant="h7_3"
                sx={{ fontWeight: 700, margin: "0px 0px 0px 15px" }}
              >
                {t("Flight Details")}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection : {xs : 'column', sm : 'row'},
                margin: isMobile ? "10px 20px 10px 20px" : "20px 50px 20px 50px",
                gap : '10px',
                flexWrap : 'wrap'
              }}
            >
              <Box>
                <InputLabel sx={{ marginBottom: "10px" }} variant="standard">
                  {t("Flight Number")}
                </InputLabel>
                <Typography variant="h7_1" color="text_blue">
                  {ServicesValue?.fligt_no || '-'}
                </Typography>
              </Box>

              <Box sx={{width : {xs : '100%' ,sm : '30%'}}}>
                <Typography variant="h7_2">
                  {t("Landing Services (Optional)")}
                </Typography>
                <br />
                {ServicesData.map((service, index) => (
                  <>
                  <Box sx={{display : 'flex', gap : '10px'}}>
                  <Typography sx={{color : 'rgba(26, 36, 97, 1)'}}>{service.title} -</Typography>
                  <Typography sx={{color : landingServices?.includes(service._id) ? 'rgba(82, 173, 51, 1)' : 'gray', fontWeight : 700}}>{landingServices?.includes(service._id) ? " Included" : " Not Included"}</Typography>
                  </Box>
                  </>
                ))}
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection : {xs : 'column', sm : 'row'},
                margin: isMobile ? "10px 20px 10px 20px" : "20px 50px 20px 50px",
                gap : '10px'

              }}
            >
              <Box>
                <InputLabel sx={{ marginBottom: "10px" }} variant="standard">
                  {t("Arrival Date")}
                </InputLabel>
                <Typography variant="h7_1" color="text_blue">
                  {moment(ServicesValue?.arrival_date?.$d).format(
                    "MMM DD, YYYY"
                  ) || '-'}
                </Typography>
              </Box>

              <Box sx={{width : {xs : '100%',  sm : '30%'}}}>
                <Typography variant="h7_2">
                  {t("Other Chargeable Services (Optional)")}
                </Typography>
                <br />
                {OtherServiceData.map((service, index) => (
                  <>
                  <Box sx={{display : 'flex', gap : '10px'}}>
                  <Typography sx={{color : 'rgba(26, 36, 97, 1)'}}>{service?.title} -</Typography>
                  <Typography sx={{color : otherServices?.includes(service._id) ? 'rgba(82, 173, 51, 1)' : 'gray', fontWeight : 700}}>{otherServices?.includes(service._id) ? "Included" : "Not Included"}</Typography>
                  </Box>
                  </>
                ))}
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                margin: isMobile ? "10px 20px 10px 20px" : "20px 50px 20px 50px",
              }}
            >
              <Box>
                <InputLabel
                  sx={{ marginBottom: "10px" }}
                  mt={3}
                  variant="standard"
                >
                  {t("Arrival Time")}
                </InputLabel>
                <Typography variant="h7_1" color="text_blue">
                  {moment(ServicesValue?.arrival_date?.$d).format("hh:mm A") || '-'}
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#FCFCFD",
                padding: 2,
                border: "1px solid #E5E7EB",
                borderRadius: "6px 6px 0px 0px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <FormIcon style={{ marginRight: "10px" }} />
                <Typography variant="h6_1" color="#AD3333">
                  {t("NOTE")}
                </Typography>
              </Box>
              {/* <Button
                onClick={() => {
                  setStepperCount(3);
                }}
                startIcon={<EditIcon fill="#FFFFFF" />}
                sx={{
                  height: "40px",
                  width: "100px",
                  fontSize: "16px",
                  fontWeight: 500,
                }}
                variant="standard"
              >
                Edit
              </Button> */}
            </Box>

            <Box sx={{ m: 3 }}>
              <Typography>{Details?.note || '-'}</Typography>
            </Box>

            <Divider />
            <Stack
              margin="10px"
              gap="10px"
              direction="row"
              alignItems="center"
              justifyContent="start"
            >
              <Checkbox checked={checked} onChange={checkBoxChange} />
              <Typography variant="h9_1" color="text_blue">
                {t("I agree all the provided Information are correct")}
              </Typography>
            </Stack>

            <Stack
              sx={{
                border: "1px solid #e5e5e5",
                padding: "20px",
                display: "flex",
                justifyContent: "flex-end",
              }}
              direction="row"
              alignItems="center"
              justifyContent="start"
            >
              <Button
                disabled={!checked}
                variant="standard"
                onClick={() => {
                  setStepperCount(5);
                  handleSubmit()
                  // HandleSubmitSteps()
                }}
              >
                {t("Continue")}
              </Button>
            </Stack>
          </CardContent>
        </Card>
      </Box>
    </>
  );
}
